import { cx } from "@emotion/css";
import type { ReactNode } from "react";
import type { FaqContent } from "src/api/faq";
import { BackButton } from "src/components/Default/LekUI/BackButton";
import { GuideBlock } from "src/components/Guide/GuideBlock";
import { useSlot } from "src/components/Slots/SlotsContext";
import isMobile from "src/helpers/isMobile";
import isPes, { getService } from "src/helpers/isPes";
import { EMPTY_FAQ_ITEM } from "src/hooks/useFaq";
import { getUserSpecialisationName } from "src/hooks/useUser";

interface GuideSectionProps {
	section: FaqContent;
	// rendered under the blocks in view mode only (hidden while editing)
	footer?: ReactNode;
}

export const GuideSection = ({ section, footer }: GuideSectionProps) => {
	const AdminSection = useSlot("guideSection");

	const header = (
		<div className="flex items-center gap-8">
			{isMobile() && <BackButton testId="guide-back" />}
			<div className="bg-grey text-primary w-fit-content p-8 border-radius-6 size-14-light">
				{isPes() ? `PES - ${getUserSpecialisationName()}` : getService()}
			</div>
		</div>
	);

	const items = section.items.filter(
		({ content }) => content !== EMPTY_FAQ_ITEM,
	);

	const view = (
		<div
			className={cx("flex-1 flex flex-col gap-24 w-100 align-self-stretch", {
				"pb-32": !footer,
			})}
			data-test-id="guide-section"
		>
			{items.length ? (
				items.map((item, index) => (
					<GuideBlock
						key={item.id}
						item={item}
						header={index === 0 ? header : undefined}
					/>
				))
			) : (
				<div className="basic-box w-100">{header}</div>
			)}
			{footer}
		</div>
	);

	return AdminSection ? (
		<AdminSection section={section}>{view}</AdminSection>
	) : (
		view
	);
};
